import { css, keyframes } from '@emotion/css';
import React, { CSSProperties } from 'react';

const beat = keyframes`
  0%, 30%, 70%, 100% {
    transform: rotate(45deg);
    border-radius: 50%;
  }
  50%, 55% {
    transform: rotate(45deg) scale(1.8);
    border-radius: 40%;
  }
`;

interface ClassicLoadingProps {
  size?: number;
  dotRadius?: number;
  color?: string;
  style?: CSSProperties;
}

export const ClassicLoading: React.FC<ClassicLoadingProps> = props => {
  const size = props.size || 50;
  const dotRadius = props.dotRadius || 2.5;
  const dotDiameter = dotRadius * 2;
  const color = props.color || '#eeeeee';
  return (
    <div
      className={css`
        width: ${size}px;
        height: ${size}px;
        position: relative;

        div {
          position: absolute;
          width: ${dotDiameter}px;
          height: ${dotDiameter}px;
          background-color: ${color};
          border-radius: 50%;
          animation: ${beat} 1s ease-in-out alternate infinite;
        }
        div:nth-of-type(1) {
          top: calc(15% - ${dotRadius}px);
          left: calc(50% - ${dotRadius}px);
        }
        div:nth-of-type(2) {
          top: calc(25% - ${dotRadius}px);
          right: calc(25% - ${dotRadius}px);
          animation-delay: 125ms;
        }
        div:nth-of-type(3) {
          top: calc(50% - ${dotRadius}px);
          right: calc(15% - ${dotRadius}px);
          animation-delay: 250ms;
        }
        div:nth-of-type(4) {
          bottom: calc(25% - ${dotRadius}px);
          right: calc(25% - ${dotRadius}px);
          animation-delay: 375ms;
        }
        div:nth-of-type(5) {
          bottom: calc(15% - ${dotRadius}px);
          right: calc(50% - ${dotRadius}px);
          animation-delay: 500ms;
        }
        div:nth-of-type(6) {
          left: calc(25% - ${dotRadius}px);
          bottom: calc(25% - ${dotRadius}px);
          animation-delay: 625ms;
        }
        div:nth-of-type(7) {
          top: calc(50% - ${dotRadius}px);
          left: calc(15% - ${dotRadius}px);
          animation-delay: 750ms;
        }
        div:nth-of-type(8) {
          top: calc(25% - ${dotRadius}px);
          left: calc(25% - ${dotRadius}px);
          animation-delay: 875ms;
        }
      `}
      style={props.style ?? {}}
    >
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};
